import { CommonServices } from "@/services/CommonServices";
import { apiurl} from '@/config';
import QRCode from 'qrcode'

class _QrGenerator {

    GetQrUrl(identifier): string{
        let url = apiurl + 'api/ScanQr/Scan?identifier=' + identifier;
        return url;
    }

    GenerateQr(identifier): Promise<string>{
        let url = this.GetQrUrl(identifier);
        return QRCode.toDataURL(url);
    }

}

export let QrGenerator = new _QrGenerator();
